import * as React from 'react';
import { LazyLoader } from '../LazyLoader/LazyLoader';

export interface ImageProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  alt?: string;
  offset?: number;
  src?: string;
  className?: string;
  dataAssetId?: string;
  isLazyLoad?: boolean;
}

export const Image = React.forwardRef<HTMLImageElement, ImageProps>(({
  className,
  alt,
  offset,
  src,
  isLazyLoad = true,
  dataAssetId,
  ...props
}, ref) => {
  const dataAssetIDAttr = dataAssetId && { 'data-asset-id': dataAssetId };
  const image = (
    <img
      className={className}
      alt={alt}
      src={src}
      ref={ref}
      data-test="image"
      data-loading="lazy"
      {...dataAssetIDAttr}
      {...props}
    />
  );
  return (
    isLazyLoad ?
      (
        <LazyLoader offset={offset}>
          {image}
        </LazyLoader>
      ) : image
  );
});

Image.displayName = 'Image';
